"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var listActions = require("@caddigital/sok-reducers/lib/actions/user/list");
var SearchBar_1 = require("./SearchBar");
var List_1 = require("./List");
var Types = require("types");
var translate_1 = require("utils/translate");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        limit: state.user.list.limit,
        order: state.user.list.order,
        orderBy: state.user.list.orderBy,
        searchString: state.user.list.searchString
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    setSearchString: function (props, value) { return (dispatch(listActions.setSearchString(value)),
        dispatch(listActions.setOffset(0)),
        dispatch(listActions.fetchUserListRequest(0, props.limit, props.order, props.orderBy, value))); },
    clear: function () { return dispatch(listActions.clear()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: 'content-wrapper-content' },
        React.createElement("div", { className: 'user-management-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/" }, "SokoPro"),
                    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/system')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/system/userManagement'))),
                React.createElement(SearchBar_1.default, __assign({}, props)),
                React.createElement(List_1.default, { onCloseAction: listActions.fetchUserListRequest(0, props.limit, props.order, props.orderBy, props.searchString) })))))); });
